export default __webpack_public_path__ + "static/media/type_1.b61ac7cc.svg";